import { render, staticRenderFns } from "./owner.vue?vue&type=template&id=755a6671&scoped=true"
import script from "./owner.vue?vue&type=script&lang=js"
export * from "./owner.vue?vue&type=script&lang=js"
import style0 from "./owner.vue?vue&type=style&index=0&id=755a6671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a6671",
  null
  
)

export default component.exports